import type { BirdIconDef } from '../types';
import { CUSTOM_BIRD_ICONS } from './custom';
import { heuristicBirdIcon } from './heuristic';

export function getBirdIconDef(name: string, solid = false): BirdIconDef {
  const custom = CUSTOM_BIRD_ICONS[name];
  const base = custom ?? heuristicBirdIcon(name);
  if (!solid) return base;
  return { ...base, solid: true };
}

export { CUSTOM_BIRD_ICONS };
